import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BlueprintsProvider } from "blueprints2";

import "blueprints2/lib/core.css";
import "blueprints2/lib/utilities.css";
import translations from "./locales/react-translations.js";

const workspace = process.env.REACT_APP_WORKSPACE;
//const env = process.env.NODE_ENV;
var forceJALang = workspace === "jp";
// check browser language, set fallback if no translations exist
const translatedLangs = ["en-US", "ja"];
let locale = window.navigator.userLanguage || window.navigator.language;
if (forceJALang) {
  locale = "ja";
} else if (!translatedLangs.includes(locale)) {
  locale = "en-US";
}

ReactDOM.render(
  <BlueprintsProvider messages={translations} locale={locale}>
    <App workspace={workspace} locale={locale} />
  </BlueprintsProvider>,
  document.getElementById("root")
);
